import styled from "styled-components";

import Avatar from "components/ui/Avatar";
import BuildingInterior from "components/ui/BuildingInterior";
import CharacterInfo from "components/ui/CharacterInfo";
import Fight from "components/ui/Fight";
import LinkSectorsOverlay from "components/ui/LinkSectorsOverlay";
import MiniChat from "components/ui/MiniChat";
import MiniMap from "components/ui/MiniMap";
import ShipInterior from "components/ui/ShipInterior";
import World from "components/world/World";
import { useSelector } from "react-redux";
import {
  getLocationInfo,
  getShipInteriorInfo,
} from "redux/selectors/characterSelectors";
import Controls from "./Controls";
import PlanetTravel from "./PlanetTravel";

const MapWrapper = styled.div`
  width: 100vw;
  height: 100vh; // fallback
  height: 100dvh;
  background-color: black;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
`;

export default function GameMap() {
  const { isInsideShip } = useSelector(getShipInteriorInfo);
  const { isLinkSectorsOverlayOpen } = useSelector(getLocationInfo);

  return (
    <MapWrapper>
      <World>
        <Avatar />
      </World>
      <Controls />
      <PlanetTravel />
      {isInsideShip && <ShipInterior />}
      <BuildingInterior />
      <CharacterInfo />
      <MiniMap />
      <MiniChat />
      <Fight />
      {isLinkSectorsOverlayOpen && <LinkSectorsOverlay />}
    </MapWrapper>
  );
}
